/**
 * TODO: send currently active experiments and user variant
 * as a custom dimension
 */
import Script from 'next/script';

import { markup } from 'lib/utils';

// TODO: rename to GoogleAnalytics — this loads GA4 via gtag.js (Measurement ID
// G-XXXXXXXX), not a GTM container. Also rename NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID
// → NEXT_PUBLIC_GA4_MEASUREMENT_ID across .env files and all references.

const INTERACTION_EVENTS = ['pointerdown', 'click', 'touchstart', 'keydown', 'scroll'];
// Delay before loading gtag even without user interaction, so bounce sessions
// still get a pageview recorded. requestIdleCallback with timeout is preferred;
// plain setTimeout is the fallback for browsers that don't support rIC.
const FALLBACK_DELAY_MS = 3500;

export const buildGaLoader = (gtmId) => `
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());

  function loadGtag() {
    // Idempotent: interaction listeners use { once: true } and the fallback
    // (requestIdleCallback/setTimeout) may also fire — this guard ensures a
    // single injection regardless of which trigger wins.
    if (window.__gaLoaded) return;
    window.__gaLoaded = true;

    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=${gtmId}';
    document.head.appendChild(s);

    window.gtag('config', '${gtmId}', { custom_map: { dimension2: 'version' } });
  }

  ${INTERACTION_EVENTS.map((e) => `window.addEventListener('${e}', loadGtag, { once: true, passive: true });`).join('\n  ')}

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(loadGtag, { timeout: ${FALLBACK_DELAY_MS} });
  } else {
    setTimeout(loadGtag, ${FALLBACK_DELAY_MS});
  }
`;

const GoogleTagManager = () => {
  const gtmId = process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID;

  if (!gtmId) {
    return null;
  }

  return (
    <Script
      dangerouslySetInnerHTML={markup(buildGaLoader(gtmId))}
      id="gtm-config"
      strategy="afterInteractive"
    />
  );
};

export default GoogleTagManager;
